import { render } from "./AddExcelIndi.vue?vue&type=template&id=5a4f0189"
import script from "./AddExcelIndi.vue?vue&type=script&lang=js"
export * from "./AddExcelIndi.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\esteb\\Desktop\\PlantillaEsteban\\fronted-plantilla\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__